<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '~/types/types'

/**
 * Agency's `team` wrapper. The manual grid now lives in the shared
 * site-builder layer (SiteBlocksTeamBlock, promoted from this file); all that
 * remains here is the 'bookable_staff' mode, which reads live bookable
 * profiles and so cannot be generic.
 *
 * Named TeamSourceBlock rather than TeamBlock on purpose: an app component
 * sharing a filename with a layer component shadows it, so a file named
 * TeamBlock.vue delegating to `SiteBlocksTeamBlock` would render itself
 * forever.
 */
defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <LandingBookableStaffSection v-if="data.source === 'bookable_staff'" />
  <SiteBlocksTeamBlock
    v-else
    :data="data"
    :settings="settings"
  />
</template>
